import React from "react";
import { QuestionEdit } from ".";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, PendingCommand, QuestionInterface } from "../../helpers";

interface Props {
  feedId?: number,
  templateId?: number,
  saveCallback: () => void,
  pendingCommand: PendingCommand,
  sendCommand?: (cmd: PendingCommand) => void
}

export const Questions: React.FC<Props> = props => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null);
  const [selectedQuestion, setSelectedQuestion] = React.useState<QuestionInterface>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [deleteIds, setDeleteIds] = React.useState<number[]>([]);

  const init = () => {
    if (props.templateId) ApiHelper.getAnonymous<QuestionInterface[]>("/questions/template/" + props.templateId.toString()).then(data => setQuestions(data || []));
    else if (props.feedId) ApiHelper.getAnonymous<QuestionInterface[]>("/questions/feed/" + props.feedId.toString()).then(data => setQuestions(data || []));
    else setQuestions([]);
  }


  const handleSave = async (params: { feedId: number, templateId: number }) => {
    let idx = 0;
    for (let q of questions) {
      q.feedId = params.feedId;
      q.templateId = params.templateId;
      q.sort = idx;
      idx++;
    }

    await ApiHelper.post("/questions", questions);
    if (deleteIds) {
      for (let deleteId of deleteIds) await ApiHelper.delete("/questions/" + deleteId);
    }
    props.saveCallback()
  }


  const handleParentCommand = () => {
    if (props.pendingCommand) {
      switch (props.pendingCommand.action) {
        case "save":
          handleSave(props.pendingCommand.parameter as { feedId: number; templateId: number });
          break;
      }
    }
  }


  const handleCommandReceived = (cmd: PendingCommand) => {
    const q = [...questions];
    switch (cmd.action) {
      case "cancelEditQuestion":
        setSelectedQuestion(null);
        break;
      case "updateQuestion":
        if (selectedIndex === -1) q.push(cmd.parameter);
        else q[selectedIndex] = cmd.parameter;
        setQuestions(q);
        setSelectedQuestion(null);
        break;
      case "deleteQuestion":
        const dIds = [...deleteIds];
        dIds.push(selectedQuestion.id);
        setDeleteIds(dIds);
        q.splice(selectedIndex, 1);
        setQuestions(q);
        setSelectedQuestion(null);
        break;
    }
  }

  const moveUp = (index: number) => {
    const qs = [...questions]
    const [item] = qs.splice(index, 1);
    qs.splice(index - 1, 0, item);
    setQuestions(qs);
  }

  const moveDown = (index: number) => {
    const qs = [...questions]
    const [item] = qs.splice(index, 1);
    qs.splice(index + 1, 0, item);
    setQuestions(qs);
  }


  const getTable = () => {
    if (questions === null) return <Loading />
    else {
      if (questions.length === 0) return <p>There are no questions yet.</p>
      else {
        const rows: React.ReactElement[] = [];
        let i = 0;
        for (let q of questions) {
          const index = i;
          const upLink = (i === 0) ? <span style={{ paddingLeft: 14 }}>&nbsp;</span> : <a href="about:blank" onClick={(e) => { e.preventDefault(); moveUp(index) }} ><i className="fas fa-arrow-up"></i></a>
          const downLink = (i === questions.length - 1) ? <></> : <a href="about:blank" onClick={(e) => { e.preventDefault(); moveDown(index) }} style={{ marginLeft: 10 }} ><i className="fas fa-arrow-down"></i></a>
          rows.push(<tr>
            <td><a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedQuestion(q); setSelectedIndex(index); }} >{"{" + q.keyName + "}"}</a></td>
            <td>{q.title}</td>
            <td>{upLink}{downLink}</td>
          </tr>);
          i++;
        }
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Key Name</th><th>Title</th><th>Sort</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const getNewButton = () => {
    return <a href="about:blank" className="btn btn-sm btn-success" onClick={(e) => { e.preventDefault(); setSelectedIndex(-1); setSelectedQuestion({ parentId: 0 }); }}><i className="fas fa-plus" style={{ color: "#FFF" }}></i> New</a>
  }


  React.useEffect(handleParentCommand, [props.pendingCommand]); // eslint-disable-line
  React.useEffect(init, [props.templateId || props.feedId]); // eslint-disable-line

  const getRootQuestions = () => {
    const result: QuestionInterface[] = [];
    questions?.forEach(q => { if (q.id !== 0 && q.parentId === 0) result.push(q); });
    return result;
  }

  if (selectedQuestion) return <QuestionEdit question={selectedQuestion} sendCommand={handleCommandReceived} rootQuestions={getRootQuestions()} />
  return (<DisplayBox headerText="Questions" headerIcon="fas fa-question" editContent={getNewButton()} >
    {getTable()}
  </DisplayBox>);

};